// TODO : split qquick payments in different components
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  carouselCurrentItemSelector,
  accountsSelector,
  remarksSelector
} from '../../../selectors'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoButton from '../../../components/NeoButton/NeoButton'
import useTabStyle from '../../../hooks/useTabStyle'
import { useTranslation } from 'react-i18next'
import {
  SIDENAV_KEYS,
  MENU_SIDEBAR_KEYS,
  LANDING_KEYS,
  DIALOG_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { useHistory } from 'react-router-dom'
import QRCode from 'qrcode.react'

export default function QRCodePayment() {
  const history = useHistory()
  const [showCard, setShowCard] = useState(true)
  const [stage, setStage] = useState(0)
  const current = useSelector(carouselCurrentItemSelector)
  const accounts = useSelector(accountsSelector)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [randomKey, setRandomKeys] = useState('')
  const [otpEnable, setOtpEnable] = useState(false)
  const { t } = useTranslation()
  const inputFile = useRef(null)
  const [imgLocation, setImgLocation] = useState('')
  const [responseValues, setResponseValues] = useState({})
  const [otp, setOtp] = useState('')
  const [banks, setBanks] = useState({})
  const [requestType, setRequestType] = useState('')
  const [selectedBank, setSelectedBank] = useState('')
  const [formValues, setFormValues] = useState()
  const { classes } = useTabStyle()
  const [terms, setTerms] = useState('')
  const [tnc, setTnc] = useState(false)
  const [tncError, setTncError] = useState(false)
  const [charges, setCharges] = useState(0)
  const [remarksList, setRemarksList] = useState([])
  const remarks = useSelector(remarksSelector)
  const dispatch = useDispatch()

  const downloadQR = useCallback(() => {
    const canvas = document.getElementById('myQRCode')
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = 'MyQRCode.png'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }, [])

  function renderQRPay() {
    return (
      <div>
        <div className='heading-style'>{t(SIDENAV_KEYS.QR_KEYS.TITLE)}</div>
        {/* <NeoButton
          type='button'
          text='Upload QR Code'
          mode='newDesign'
          ref={inputFile}
          onClick={() => {
            inputFile.current.click()
          }}
        />

        <input
          type='file'
          id='file'
          accept='.png'
          ref={inputFile}
          style={{ display: 'none' }}
          onChange={(e) => setImgLocation(e.target.files[0])}
        /> */}
        <div className='text-center'>
          <QRCode
            includeMargin
            id='myQRCode'
            className='shadow-lg'
            size={250}
            value={(accounts && current?.qrKey) || 'hello'}
          />
        </div>
        <div className='mt-5 col-8 mx-auto px-0'>
          <NeoButton 
            tabIndex='1'
            type='button'
            className='btn btn-neo'
            mode='newDesign'
            text={t(SIDENAV_KEYS.QR_KEYS.SHARE)}
            onClick={downloadQR}
          />
        </div>
      </div>
    )
  }

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderQRPay()
      //   case 1:
      //     return renderTransferConfirm()
      //   case 2:
      //     return (
      //       <div className='bg-white'>
      //         <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmInstantTransfer} loading={loading} />
      //       </div>
      //     )
      //     break
      //   case 3:
      //     return (
      //       <NeoSuccess
      //         message={message}
      //         onClick={() => {
      //           setStage(0)
      //           setRequestType('')
      //           setShowCard(true)
      //         }}
      //       />
      //     )
    }
  }

  return (
    <LayoutWithAccountCard breadCumKey="QR_CODE">
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
